<a [routerLink]="link()">
  <div class="inner-container">
    <img
      class="icon"
      role="presentation"
      width="128"
      height="107"
      alt=""
      [ngSrc]="icon()"
    />

    <h2>{{ name() }}</h2>
    <p class="badges">
      <lib-web-competition-badges [status]="status()" />
    </p>

    <lib-web-competition-summary
      [progress]="progress()"
      [winner]="winner()"
      [runnerUp]="runnerUp()"
      [attributes]="attributes()"
    />
  </div>
</a>
